import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from 'primereact/dropdown';
import {isArray} from 'lodash';

const TVRatings = ['NR', 'TV-Y', 'TV-Y7', 'TV-Y7FV', 'TV-G', 'TV-PG', 'TV-14', 'TV-MA'];

const tvRatingList = ({onChange, value, id}) => (
    <Dropdown
        filter={false}
        filterBy="label,value"
        filterPlaceholder="Select TV Rating"
        id={id}
        options={
            isArray(TVRatings)
                ? TVRatings.map((rating, index) => ({
                      label: rating,
                      value: index,
                  }))
                : []
        }
        showClear={false}
        style={{width: '300px'}}
        value={Number(value)}
        onChange={onChange}
    />
);

tvRatingList.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default tvRatingList;
